var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"map"}},[_c('GmapMap',{ref:"mapRef",staticClass:"content-group",staticStyle:{"width":"100%","height":"100%"},attrs:{"center":{ lat: _vm.defaultLat, lng: _vm.defaultLng },"options":{ gestureHandling: _vm.gestureHandlingProps },"zoom":12}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }